import type { IconColor } from '@freelancer/ui/icon';
import type { ButtonSize } from '../button';

export type DropdownFilterIconColor =
  | IconColor.FOREGROUND
  | IconColor.LIGHT
  | IconColor.SECONDARY;

export type DropdownFilterSize =
  | ButtonSize.MINI
  | ButtonSize.SMALL
  | ButtonSize.MID;

export enum DropdownFilterContentSize {
  FLUID = 'fluid', // Follow content's width
  INHERIT = 'inherit', // Follow trigger's width
}

export type DropdownFilterIconName =
  | 'ui-page-info'
  | 'ui-percent'
  | 'ui-tune'
  | 'ui-dollar'
  | 'ui-clock-v2'
  | 'ui-star'
  | 'ui-pin-location'
  | 'ui-switch'
  | 'ui-education'
  | 'ui-assignment-turned-in';

/** Icons that should render with fillIconFont=false */
export const ICONS_NO_FILL: readonly DropdownFilterIconName[] = [
  'ui-clock-v2',
  'ui-education',
  'ui-page-info',
];
